import * as Yup from 'yup';
import { ROI_REPORT_FIELDS } from '../container/B2B/CompanyAdmin/PeoplePlan/components/roiReportFields';

const shape = ROI_REPORT_FIELDS.reduce((acc, field) => {
  acc[field.key] = Yup.number()
    .typeError(`Please enter a valid number for ${field.label}.`)
    .min(0, `${field.label} cannot be negative.`)
    .required(`Please enter ${field.label.toLowerCase()}.`);
  return acc;
}, {});

const AddEditRoiReportValidation = Yup.object().shape(shape);

export default AddEditRoiReportValidation;
